export const API_PATH_ApiZipCreatorDownloadZip = '/services/zip-creator/apiZipCreatorDownloadZip';
